import { render, staticRenderFns } from "./video-poster.vue?vue&type=template&id=5e2d1ef0"
import script from "./video-poster.vue?vue&type=script&lang=js"
export * from "./video-poster.vue?vue&type=script&lang=js"
import style0 from "./video-poster.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports